export default __webpack_public_path__ + "static/media/Ellipse 5.438014cc.png";